import { CheckCircleOutline, CancelOutlined } from '@mui/icons-material';
import React, { IconButton } from '@mui/material';
import { StatusIndicatorProps } from './StatusIndicatorProps';

export const StatusIndicator = ({ status }: StatusIndicatorProps) => {
	return status ? (
		<IconButton color='success' aria-label='verified'>
			<CheckCircleOutline />
		</IconButton>
	) : (
		<IconButton color='error' aria-label='not verified'>
			<CancelOutlined />
		</IconButton>
	);
};
